import './ProductReview.css'
import React, { useState } from 'react'
import ConsultantComment from './productReviewConsultantComment/ProductReviewConsultantComment'
import Comment from './productReviewComment/ProductReviewComment'
import CreateComment from './productReviewCreateComment/ProductReviewCreateComment'

/**
 * Структура
 *
 * AUTHOR - фамилия имя автора
 * DATE_TIME - форматированная дата отзыва
 * RATING - рейтинг
 * POST_TEXT - текст отзыва
 * ID - идентификатор отзыва
 * POST_ID - идентификатор блога для твоара
 * BLOG_ID - идентификатор блога
 * PARENT_ID - false, т.к корневой отзыв
 * COMMENTS - список комментариев
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function ProductReview (props) {
  const [createComment, setCreateComment] = useState(false)
  const [showComments, setShowComments] = useState(false)
  const consultantGroupId = '12'

  /**
   * Формирование звезд
   * @return {*[]}
   */
  const stars = () => {
    let stars = []
    for (let i = 1; i <= 5; i++) {
      (props.RATING >= i) ?
        stars.push(<span className="star" key={i}><i className="ic-star-full"/></span>) :
        stars.push(<span className="star" key={i}><i className="ic-star"/></span>)
    }
    return stars
  }

  /**
   * Событие показа / скрытия комментариев
   * @param e
   */
  function showHideComments(e) {
    e.preventDefault()
    setShowComments(!showComments)
  }

  function showHideCreateForm(e) {
    e.preventDefault()
    setCreateComment(!createComment)
  }

  return (
    <div className="testimonial-item">
      <div className="testimonial-head">
        <div className="name-block">
          {
            props.DETAIL.AUTHOR_NAME ?
                <>
                  <span className="name">{props.DETAIL.AUTHOR_NAME}</span>,&nbsp;
                </> : <></>
          }
          <span className="date">{props.DETAIL.DATE_CREATE}</span>
        </div>
      </div>
      <div className="testimonial-body">
        <div className="rate-block">
          {
            props.hasOwnProperty('RATING') &&
            parseInt(props.RATING) > 0 ?
              <>
                <span className="rate-value">{props.RATING}</span>
                <div className="rating-visual">
                  {stars()}
                </div>
              </> :
              <span className="rate-value no-value">{props.getMessage('NO_RATING')}</span>
          }
        </div>
        <div className="testimonial-block">
          <div className="testimonial-text-block">
            <div className="testimonial-text" dangerouslySetInnerHTML={{__html: props.DETAIL.POST_TEXT}}/>
            <div className="links-row">
              <div className="links">
                <a href="#" className="more-answers-link opening-more" onClick={showHideComments}>
                  <span>{props.getMessage('ANSWERS_COUNT')} {props.hasOwnProperty('COMMENTS') && props.COMMENTS.length ? props.COMMENTS.length : '0'}</span>
                </a>
                <div className="dropdown-main-container">
                  <span className="testimonial-link-answer" onClick={showHideCreateForm}>{props.getMessage('POST_MAKE_ANSWER')}</span>
                  {
                    createComment ?
                      <CreateComment {...props} showHide={showHideCreateForm} productId={props.productId} createUrl={props.createUrl}/> :
                      <></>
                  }
                </div>
              </div>
            </div>
          </div>
          {
            props.hasOwnProperty('COMMENTS') && props.COMMENTS.length && showComments ?
              props.COMMENTS.map((comment, key) => {
                return (comment.hasOwnProperty('USER_GROUPS') && comment.USER_GROUPS.includes(consultantGroupId)) ?
                  <ConsultantComment getMessage={props.getMessage} {...comment} key={key}/> :
                  <Comment getMessage={props.getMessage} {...comment} key={key}/>
              }) :
              <></>
          }
        </div>
      </div>
    </div>
  )
}

export default ProductReview